import React, { useRef, useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import Table from "../Table";
import Card from "../Card";
import { getSharedWithMe } from "../../../redux/actions/Projects";

const Shared: React.FC<{
  getSharedWithMe: any;
  sharedWithMe: any;
  highlightProject: any;
  setHighlightProject: any;
  setEllipsisClick: any;
}> = ({
  getSharedWithMe,
  sharedWithMe,
  highlightProject,
  setHighlightProject,
  setEllipsisClick,
}) => {
  const [viewState, setViewState] = useState("box") as any;
  const handleBoxClick = () => {
    setViewState("box");
  };

  const handleListClick = () => {
    setViewState("list");
  };

  useEffect(() => {
    getSharedWithMe();
  }, []);

  return (
    <>
      <div
        className="subTitle"
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <p
          style={{ paddingLeft: "25px", fontWeight: "bold", fontSize: "16px" }}
        >
          Shared With Me
        </p>
        <div className="push">
          <i
            onClick={handleBoxClick}
            className="fa fa-th"
            style={{
              marginRight: "30px",
              color: viewState === "box" ? "black" : "lightgrey",
            }}
          ></i>
          <i
            onClick={handleListClick}
            style={{ color: viewState === "list" ? "black" : "lightgrey" }}
            className="fa fa-list-ul"
          ></i>
        </div>
      </div>
      <div
        className="header2"
        style={
          viewState === "box"
            ? {
                maxHeight: "100vh",
                overflowY: "auto",
              }
            : { marginTop: 0 }
        }
      >
        {/* all your projects here  */}
        {viewState === "box" ? (
          sharedWithMe?.map((item: any, index: number) => (
            <Card
              key={index}
              item={item}
              index={index}
              bottom={index === sharedWithMe.length - 1}
              highlightProject={highlightProject}
              setHighlightProject={setHighlightProject}
              setEllipsisClick={setEllipsisClick}
              // allItems={sharedWithMe}
            />
          ))
        ) : (
          <Table
            projectList={sharedWithMe}
            // handleClick={() => console.log("CLicked")}
            // setProjectClicked={() => console.log("CLicked")}
            // openDeleteM={() => console.log("CLicked")}
            adminFolderState={false}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  sharedWithMe: state.projects.sharedWithMe,
});

export default connect(mapStateToProps, { getSharedWithMe })(Shared) as any;
